import { IProperty } from './AndromeTV.types';

export class GlobalSettings {
  private map: Map<string, string>;

  /**
   * Creates an object that contains the global settings
   */
  constructor(settings: IProperty[]) {
    this.map = new Map();
    settings.forEach(trn => {
      this.map.set(trn.name, trn.value);
    });
  }

  /**
   * Retrieve a string value for the specified key
   */
  stringValue(key: string): string | undefined {
    return this.map.get(key);
  }

  /**
   * Retrieve a string array value for the specified key
   */
  stringArray(key: string): string[] | undefined {
    const val = this.map.get(key);
    return val ? val.split(',') : undefined;
  }

  /**
   * Retrieve the boolean value for the specified key
   */
  boolValue(key: string): boolean | undefined {
    let val = this.map.get(key);
    if (val) {
      val = val.toLowerCase();
      if (val === 'true') {
        return true;
      }
      if (val === 'false') {
        return false;
      }
    }
    return undefined;
  }

  /**
   * Retrieve the number value for the specified key
   */
  numberValue(key: string): number | undefined {
    const num = Number(this.map.get(key));
    return isNaN(num) ? undefined : num;
  }
}
